<template> 
    <div>
        <v-dialog v-model="show" max-width="550" overlay-color="#000" overlay-opacity="0.8" :persistent="loading" :transition="phoneOnly ? 'slide-y-transition' : 'dialog-transition'" :fullscreen="phoneOnly" :fluid="phoneOnly" scrollable>
            
            <v-card class="pb-1 px-0 overflow-hidden p-relative has-header" :style="`border-radius: ${phoneOnly ? 0 : 8}px!important`" :class="{'fill-height': phoneOnly}">
                <v-progress-linear v-if="loadingSpinner" :active="loadingSpinner" :indeterminate="loadingSpinner" height="1" absolute top color="white"></v-progress-linear>
                <div class="primary" :style="`${statusBarOverlay ? 'padding-top: 45px; ' : ''}`">
                    <v-tabs v-model="activeTab" color="primary" background-color="primary" dark icons-and-text grow class="px-0 mx-0 primary">
                        <v-tab v-haptic href="#videosTab" style="letter-spacing: 0">
                            الفيديوهات
                            <v-icon class="mb-1">mdi-play-box-multiple-outline</v-icon>
                        </v-tab>
                        <v-tab v-haptic href="#examsTab" style="letter-spacing: 0">
                            الامتحانات
                            <v-badge class="notification-badge mb-0 mt-2" :value="!!examsBadge" color="ebadge" bordered border-color="primary" :content="examsBadge" overlap center>
                                <v-icon class="mb-1">mdi-clipboard-text-outline</v-icon>
                            </v-badge>
                        </v-tab>
                        <v-tab v-haptic href="#filesTab" style="letter-spacing: 0">
                            المُرفقات
                            <v-icon class="mb-1">mdi-attachment</v-icon>
                        </v-tab>
                    </v-tabs>
                </div>
                <!-- <v-card-title class="mb-2">
                    <v-icon class="me-2" color="primary">mdi-play-box-multiple-outline</v-icon>
                    الفيديوهات
                </v-card-title> -->
                <!-- <v-card-subtitle></v-card-subtitle> -->
                <v-card-text class="strong-text--text mt-3 px-0">
                    <v-tabs-items v-model="activeTab">
                        <v-tab-item value="videosTab">
                            <v-alert v-if="!lecture.enable_videos" text dense outlined type="error" icon="mdi-clipboard-text" color="error" class="medium-text font-weight-bold e-link mx-4" v-ripple @click="activeTab = 'examsTab'">
                                لديك امتحانات إجبارية قبل فتح الفيديوهات
                            </v-alert>
                            <v-list v-if="videos && videos.length" class="pa-0 transparent"> 
                                <template v-for="(video, i) in videos" >
                                    <v-list-item v-haptic :disabled="!video.viewable" @click="playVideo(video)" v-ripple="phoneOnly" :key="video.id" class="px-7 py-1">
                                        <v-list-item-icon>
                                            <v-icon :color="video.viewable ? (video.views_limit - video.counted_views === 1 ? 'error' : 'primary') : ''">mdi-play-box</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{video.name}}</v-list-item-title>
                                            <v-list-item-subtitle class="d-flex" :class="{'details-text': pcOnly, 'x-small-text': phoneOnly}">
                                                <div v-if="!lecture.expired" class="text--text me-2">
                                                    <span v-if="!lecture.enable_videos">لا يمكنك مشاهدة الفيديو</span>
                                                    <span v-else-if="video.views_limit" :class="{'green--text text--darken-2': video.counted_views === 0, 'error--text': video.views_limit - video.counted_views === 1}">
                                                        تبقى <b>{{video.views_limit - video.counted_views > 0 ? video.views_limit - video.counted_views : 0}}</b>
                                                        من
                                                        {{unitFormat(video.views_limit, 'مشاهدة', 'مشاهدتين', 'مشاهدات')}}
                                                    </span>
                                                    <span v-else>لا يوجد حد للمشاهدات</span>
                                                </div>
                                                <div>
                                                    <span v-if="lecture.expired" class="error--text">
                                                        <v-icon color="error" small class="me-1">mdi-alert-outline</v-icon>
                                                        المحاضرة منتهية الصلاحية
                                                    </span>
                                                    <span v-else-if="lecture.expiry_days" class="orange--text text--darken-2">صالحة لمدة <b>{{unitFormat(lecture.expiry_days, 'يوم', 'يومين', 'أيام')}}</b></span>
                                                </div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon v-if="video.viewable" color="primary" style="transform: rotate(270deg)">mdi-open-in-new</v-icon>
                                            <v-icon v-else-if="lecture.enable_videos" color="warning">mdi-progress-alert</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-divider v-if="i < videos.length -1" :key="'d' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                </template>
                            </v-list>
                        </v-tab-item>
                        <v-tab-item value="examsTab">
                            <v-list v-if="exams && exams.length" class="pa-0 transparent"> 
                                <template v-for="(exam, i) in exams" >
                                    <v-list-item v-haptic :disabled="!exam" v-ripple="phoneOnly" :key="exam.id" class="px-7 py-1" :link="phoneOnly">
                                        <v-list-item-icon @click="phoneOnly ? openExam(exam) : undefined">
                                            <v-icon :color="exam.needs_attention ? 'error' : 'primary'">mdi-clipboard-text-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content @click="phoneOnly ? openExam(exam) : undefined">
                                            <v-list-item-title>{{exam.name}}</v-list-item-title>
                                            <v-list-item-subtitle class="text--text d-flex">
                                                <div v-if="exam.must_pass" class="d-flex">
                                                    <v-icon :color="exam.needs_attention ? 'error' : 'success darken-1'" size="16" class="me-1">mdi-{{exam.needs_attention ? 'license' : 'check'}}</v-icon>
                                                    <span :class="{'font-weight-bold': exam.needs_attention}">النجاح مطلوب</span>
                                                </div>
                                                <div v-else-if="exam.must_take" class="d-flex">
                                                    <v-icon :color="exam.needs_attention ? 'error' : 'strong-text'" size="16" class="me-1">mdi-{{exam.needs_attention ? 'login' : 'check'}}</v-icon>
                                                    <span>دخول الامتحان مطلوب</span>
                                                </div>

                                                <div v-if="exam.navigate_to_alternative && exam.alternative_exam" class="d-flex ms-2">
                                                    <v-icon color="primary" size="16" class="me-1">mdi-reload</v-icon>
                                                    <span>تجربة مع امتحان آخر</span>
                                                    <!-- <span>{{exam.alternative_exam.name}}</span> -->
                                                </div>
                                                <div v-else-if="exam.questions_count || exam.questions_count === 0" class="d-flex ms-2">
                                                    <v-icon color="primary" size="16" class="me-1">mdi-file-question-outline</v-icon>
                                                    <span>{{unitFormat(exam.questions_count, 'سؤال', 'سؤالين', 'أسئلة')}}</span>
                                                </div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-btn v-if="pcOnly" :disabled="openingExam" :color="exam.navigate_to_alternative ? (exam.needs_attention ? 'red darken-1' : 'success darken-1') : 'primary'" dark :outlined="!exam.needs_attention" @click.stop.prevent="openExam(exam)">
                                                {{exam.navigate_to_alternative ? 'الامتحان البديل' : 'فتح الامتحان'}}
                                                <v-icon right>mdi-chevron-left</v-icon>
                                            </v-btn>
                                            <v-icon v-else>mdi-arrow-left</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-divider v-if="i < exams.length -1" :key="'d' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                </template>
                            </v-list>
                            <div v-else class="mt-3 px-4">
                                <v-alert text type="info" color="blue-grey darken-2" icon="mdi-clipboard-text-outline">
                                    لا يوجد امتحانات مرتبطة بهذه المحاضرة
                                </v-alert>
                            </div>
                        </v-tab-item>
                        <v-tab-item value="filesTab">
                            

                            <v-list v-if="attachments && attachments.length" class="pa-0 transparent"> 
                                <template v-for="(attachment, i) in attachments" >
                                    <v-list-item v-haptic :key="attachment.id" :href="attachment.url" download class="px-7 py-1">
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-paperclip</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{attachment.name}}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <v-chip dark :color="attachment.meta.extension === 'pdf' ? 'deep-orange' : 'primary'" label small class="me-1">
                                                    <v-icon class="me-1">mdi-file</v-icon>
                                                    {{attachment.meta.extension.toUpperCase()}}
                                                </v-chip>
                                                <v-chip label small class="ltr-dir">
                                                    {{attachment.size}}
                                                </v-chip>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-btn as="a" icon large color="secondary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop :href="attachment.url">
                                                <v-icon size="22">mdi-download</v-icon>
                                            </v-btn>
                                        </v-list-item-icon>
                                    </v-list-item>

                                    <v-divider v-if="i < attachments.length -1" :key="'d' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                </template>
                            </v-list>
                            <div v-else class="mt-3 px-4">
                                <v-alert text type="info" color="blue-grey darken-2" icon="mdi-clipboard-text-outline">
                                    لا يوجد مُرفقات مرتبطة بهذه المحاضرة
                                </v-alert>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
                <v-card-actions class="pt-0 pb-4">
                    <div :style="`${bottomSafeArea ? 'padding-bottom: 20px;' : ''}`" class="w-100">
                        <v-btn block text class="grey lighten-4" @click="show = false">
                            <v-icon left>mdi-arrow-right</v-icon>
                            الرجوع
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="phoneDownloadDialog" max-width="400" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="mb-2">حمل تطبيق الهاتف</v-card-title>
                <v-card-subtitle>لكي تتمكن من مشاهدة المحاضرة؛ يجب عليك تحميل تطبيق الهاتف</v-card-subtitle>
                <v-card-text>
                
                    <div class="d-flex justify-center align-center">
                        <store-badge type="playstore" width="150px" />
                        <store-badge type="appstore" width="120px" />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <video-dialog v-model="showVideoDialog" :video="showVideo" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import StoreBadge from '../default/store-badge'
import VideoDialog from './video-dialog'

export default {
    props: {
        value: {},
        lecture: {},
        videos: {},
        exams: {},
        attachments: {},
        pay_type: {}
    },
    components: {StoreBadge, VideoDialog},
    data(){
        return {
            activeTab: '',
            show: false,
            loading: false,

            phoneDownloadDialog: false,

            showVideoDialog: false,
            showVideo: null,

            openingExam: false,
        }
    },
    computed: {
        ...GlobalComputed,
        loadingSpinner(){
            return this.openingExam;
        },
        examsBadge(){
            let count = 0;
            const exams = this.exams ? this.exams : [];
            exams.forEach(exam=>{
                if (exam.needs_attention){
                    count += 1;
                }
            })
            return count;
        },
        statusBarOverlay(){
            return this.platform === 'ios';
        },
        bottomSafeArea(){
            return this.platform === 'ios';
        },
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {
        playVideo(video){
            this.show = false;
            if (this.platform === 'web' && !this.miniDerasaPlatform){
                if (this.pcOnly){
                    const apiToken = window.localStorage.getItem('tK'); // user oauth token
                    const deepLinkProtocol = process.env.VUE_APP_DESKTOP_APP_PROTOCOL;
                    const url = `${deepLinkProtocol}://video?videoId=${video.id}&token=${apiToken}`
                    window.open(url, '_self')
                }else{
                    // on phone, open download-phone-app dialog
                    this.phoneDownloadDialog = true;
                }
            }else if (this.platform === 'android' || this.platform === 'ios' || this.miniDerasaPlatform){
                window.setTimeout(()=>{
                    this.showVideoDialog = true;
                    this.showVideo = video;
                }, 200);
            }
        },

        openExam(exam){
            const exam_code = exam.navigate_to_alternative && exam.alternative_exam ? exam.alternative_exam.exam_code : exam.exam_code;
            // get exam details
            if (!this.openingExam){
                this.openingExam = true;
                window.axios.get(`/exams/details?exam_code=${exam_code}`).then(response=>{
                    this.openingExam = false;
                    this.show = false;
                    const examData = response.data.data;
                    window.setTimeout(()=>{
                        this.$router.push({name: 'exams', params: {examData: examData}, query: {course_id: this.lecture.course_id}})
                    }, 600);

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_FOUND'){
                            this.showMsg('الامتحان غير موجود', 'error');
                        }else if (msg === 'EXAM_NOT_STARTED'){
                            this.showMsg('لم يبدأ الامتحان بعد، انتظر حتى يأتي وقت الامتحان', 'error');
                        }else if (msg === 'EXAM_ENDED'){
                            this.showMsg('انتهى الوقت المسموح فيه بدخول الامتحان', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.openingExam = false;
                })
            }
        },
        ...GlobalMethods,
    },
    mounted(){

        if (this.capRunning){
            document.addEventListener('backbuttonclicked', ()=>{
                if (this.showVideoDialog){
                    this.showVideoDialog = false;
                }else if (this.show){
                    this.show = false;
                }else{
                    if (this.$route.name === 'course'){
                        this.$router.go(-1);
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss">

</style>